import { glammerDomain } from './clientDomainPath';

export type IsLoadedWithGlammerDomain = () => boolean;
export const isLoadedWithGlammerDomain: IsLoadedWithGlammerDomain = () => window.location.hostname === glammerDomain;
